import React, { useEffect, useRef, useState } from 'react';
import cls from 'classnames';
import { Tooltip } from 'antd';
import './styles.less';

const StoreOverviewStat = ({data, shopUrl}) => {

  const valueRef = useRef(null);

  const [hasEllipsis, setHasEllipsis] = useState(false);

  useEffect(() => {
    if (valueRef.current) {
      const element = valueRef.current;
      const isOverflowing = element.scrollWidth > element.clientWidth;

      setHasEllipsis(isOverflowing);
    }
  }, [data?.value])

  return (
    <div className={cls('store-overview-stat-wrapper', {
      theme: data?.title === 'Store theme'
    })}>
      <div className="title">
        {data?.title}
      </div>
      {
        hasEllipsis ?
          <Tooltip title={data?.value}
                   placement={'top'}
          >
            <div className="value"
                 ref={valueRef}
            >
              {data?.value ? data?.value : 'None'}
              {
                data?.view ?
                  <span onClick={() => window.open(`${shopUrl}/${data?.title?.includes('products') ? 'products' : 'collections'}`, '_blank') }
                  >
                    View <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6.16667 2.5H4.63333C3.8866 2.5 3.51323 2.5 3.22801 2.64532C2.97713 2.77316 2.77316 2.97713 2.64532 3.22801C2.5 3.51323 2.5 3.8866 2.5 4.63333V11.3667C2.5 12.1134 2.5 12.4868 2.64532 12.772C2.77316 13.0229 2.97713 13.2268 3.22801 13.3547C3.51323 13.5 3.8866 13.5 4.63333 13.5H11.3667C12.1134 13.5 12.4868 13.5 12.772 13.3547C13.0229 13.2268 13.2268 13.0229 13.3547 12.772C13.5 12.4868 13.5 12.1134 13.5 11.3667V9.83333M9.16667 2.5H13.5M13.5 2.5V6.83333M13.5 2.5L7.33333 8.66667" stroke="#225AEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                  </span>
                  :
                  null
              }
            </div>
          </Tooltip>
          :
          <div className="value"
               ref={valueRef}
          >
            {data?.value ? data?.value : 'None'}
            {
              data?.view ?
                <span onClick={() => window.open(`${shopUrl}/${data?.title?.includes('products') ? 'products' : 'collections'}`, '_blank') }
                >
                  View <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6.16667 2.5H4.63333C3.8866 2.5 3.51323 2.5 3.22801 2.64532C2.97713 2.77316 2.77316 2.97713 2.64532 3.22801C2.5 3.51323 2.5 3.8866 2.5 4.63333V11.3667C2.5 12.1134 2.5 12.4868 2.64532 12.772C2.77316 13.0229 2.97713 13.2268 3.22801 13.3547C3.51323 13.5 3.8866 13.5 4.63333 13.5H11.3667C12.1134 13.5 12.4868 13.5 12.772 13.3547C13.0229 13.2268 13.2268 13.0229 13.3547 12.772C13.5 12.4868 13.5 12.1134 13.5 11.3667V9.83333M9.16667 2.5H13.5M13.5 2.5V6.83333M13.5 2.5L7.33333 8.66667" stroke="#225AEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </span>
                :
                null
            }
          </div>
      }
    </div>
  );
};

export default StoreOverviewStat;
